import { render, staticRenderFns } from "./MilestoneNameDrawer.vue?vue&type=template&id=62ea0252&scoped=true"
import script from "./MilestoneNameDrawer.vue?vue&type=script&lang=js"
export * from "./MilestoneNameDrawer.vue?vue&type=script&lang=js"
import style0 from "./MilestoneNameDrawer.vue?vue&type=style&index=0&id=62ea0252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ea0252",
  null
  
)

export default component.exports